import { HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Question } from './question.model';

export interface Template {
  id: number;
  name: string;
  type: TemplateType;
  isActive: boolean;
  status: TemplateStatus;
}

export interface TemplateOverview {
  templateId: number;
  templateName: string;
  templateType: TemplateType;
  templateActive: boolean;
  templateStatus: TemplateStatus;
  numberOfQuestions: number;
}

export interface TemplateWithQuestions extends Template {
  questions: TemplateQuestionResponse[];
}

export interface CreateTemplateRequest {
  name: string;
  type: TemplateType;
}

export interface CreateTemplateQuestionRequest {
  questionId: number;
  revieweeVisible: boolean;
  commentOptional: boolean;
  questionOptional: boolean;
  questionOrder: number;
}

export interface CreateTemplate {
  name: string;
  type: TemplateType;
  questions: TemplateQuestion[];
}

export interface TemplateSearchRequest {
  search?: string;
  type?: TemplateType;
  paginate?: boolean;
  params?: HttpParams;
}

export interface TemplateQuestionResponse {
  id: number;
  templateResponse: Template;
  questionResponse: Question;
  revieweeVisible: boolean;
  commentOptional: boolean;
  questionOptional: boolean;
  questionOrder: number;
}

// same as enum ReviewType from review.model.ts
// maybe we should use ReviewType and remove this enum
export enum TemplateType {
  SURVEY = 'SURVEY',
  REVIEW = 'REVIEW',
  PROBATION_REVIEW = 'PROBATION_REVIEW',
}

export interface TemplateTypeVisual {
  value: TemplateType;
  name: string;
}

export function getTemplateTypeVisuals(translateService: TranslateService): TemplateTypeVisual[] {
  return [
    {
      value: TemplateType.REVIEW,
      name: translateService.instant('ADMIN.TEMPLATES.TYPES.REVIEW'),
    },
    {
      value: TemplateType.PROBATION_REVIEW,
      name: translateService.instant('ADMIN.TEMPLATES.TYPES.PROBATION_REVIEW'),
    },
  ];
}

export enum TemplateStatus {
  DRAFT = 'DRAFT',
  IN_USE = 'IN_USE',
}

export interface TemplateQuestion {
  question: Question;
  isCommentOptional: boolean;
  showResponseToReviewee: boolean;
  isQuestionOptional: boolean;
  questionOrder?: number;
  required?: boolean;
  isDisabled?: boolean;
}
